const TENANT_STORAGE_KEY = 'selected_tenant_id';

export const getSelectedTenantId = () => localStorage.getItem(TENANT_STORAGE_KEY) || '';

export const setSelectedTenantId = (tenantId) => {
  if (tenantId) {
    localStorage.setItem(TENANT_STORAGE_KEY, tenantId);
  } else {
    localStorage.removeItem(TENANT_STORAGE_KEY);
  }
};

export const clearSelectedTenantId = () => {
  localStorage.removeItem(TENANT_STORAGE_KEY);
};

export default TENANT_STORAGE_KEY;
